module.exports = __webpack_public_path__ + "img/icon_gasoline_un.99e3063c.png";